import React, { createContext, useState, ReactNode } from 'react';

interface ReservationContextType {
  reservations: Record<string, any>;
  setReservations: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  checkInError: string;
  setcheckInError: React.Dispatch<React.SetStateAction<string>>;
}

export const ReservationContext = createContext<ReservationContextType>({
  reservations: {},
  setReservations: () => {},
  checkInError: '',
  setcheckInError: () => {}
});

interface ReservationProviderProps {
  children: ReactNode;
}

export const ReservationProvider: React.FC<ReservationProviderProps> = ({ children }) => {
  const [reservations, setReservations] = useState<Record<string, any>>({});
  const [checkInError, setcheckInError] = useState('')

  return (
    <ReservationContext.Provider value={{ reservations, setReservations , checkInError, setcheckInError }}>
      {children}
    </ReservationContext.Provider>
  );
};